import { useEffect, useState } from 'react';
import {
  Row,
  Col,
} from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { FieldType } from '../../../../../graphql';

const DateField = ({
  id,
  top,
  left,
  height,
  width,
  complete,
  handleFieldClick,
  pendingSubmit,
}) => {
  const [date, setDate] = useState(null);

  useEffect(() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();

    setDate(`${mm}/${dd}/${yyyy}`)
  }, []);

  return (
    <div
      className={`field ${complete && "completed-field"}`}
      style={{
        top,
        left,
        height,
        width,
        cursor: pendingSubmit ? 'pointer' : 'default',
      }}
      onClick={() => {
        if (pendingSubmit) {
          handleFieldClick(FieldType.Date, id);
        }
      }}
    >
      <Row
        justify="center"
        gutter={10}
      >
        <Col span={6}>
          {pendingSubmit && (
            <div style={{ textAlign: 'center' }}>
              <CalendarOutlined color="#595959" />
            </div>
          )}
        </Col>
        <Col span={18}>
          <p style={{ textDecoration: 'underline', color: '#595959', margin: 0 }}>
            {complete ? date : 'Date'}
          </p>
        </Col>
      </Row>
    </div>
  );
}

export default DateField;
